import { render, staticRenderFns } from "./PeTwoPaneModal.vue?vue&type=template&id=994b911c&"
import script from "./PeTwoPaneModal.vue?vue&type=script&lang=js&"
export * from "./PeTwoPaneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports